import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CategoryPage from "../pages/category/page";
import DetailPage from "../pages/detail/page";
import SearchPage from "../pages/search/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";
import SiteLayout from "../components/feature/SiteLayout";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "category/:id",
        element: <CategoryPage />,
      },
      {
        path: "detail/:id",
        element: <DetailPage />,
      },
      {
        path: "search",
        element: <SearchPage />,
      },
      {
        path: "about",
        element: <AboutPage />,
      },
      {
        path: "contact",
        element: <ContactPage />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;